import React, { useEffect, useMemo, useRef, useState } from 'react';
import { StaticMapProps } from 'types';
import { getGreetingPosition } from 'utils/helpers/mapRenderers';

const StaticMapElements: React.FC<StaticMapProps> = ({
  scholar,
  staticElements,
}) => {
  const greetingRef = useRef<SVGTextElement>(null);
  const [greetingPosition, setGreetingPosition] = useState(0);

  const greeting = useMemo(() => {
    return scholar ? `Hi, ${scholar.name}!` : 'Hello there!';
  }, [scholar]);

  useEffect(() => {
    if (greetingRef.current) {
      const pos = getGreetingPosition(greetingRef.current);
      setGreetingPosition(pos);
    }
  }, [scholar]);

  return (
    <g className="static-map-elements">
      {staticElements}
      <g>
        <text
          ref={greetingRef}
          transform={`matrix(1 0 0 1 ${greetingPosition} 76.219)`}
          className="hello-kid"
          opacity={greetingPosition > 0 ? 1 : 0}
        >
          {greeting}
        </text>
      </g>
    </g>
  );
};

export default StaticMapElements;
